import React from "react";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";

const styles = {
  container: (provided, state) => ({
    ...provided,
    margin: 0
  }),
  control: (provided, state) => {
    let selectBorderColor = "rgba(200, 200, 200, 0.9)";
    if (state.selectProps.error) selectBorderColor = "red";
    // "state.selectProps" references the component props

    return {
      ...provided,
      borderColor: selectBorderColor,
      minHeight: "42px !important"
    };
  }
};

export const CustomSelect = (props) => {
  const { hasError } = props;
  return <Select error={hasError} styles={styles} {...props} />;
};

export const Creatable = (props) => {
  const { hasError } = props;
  return <CreatableSelect error={hasError} styles={styles} {...props} />;
};
